import {NgModule} from '@angular/core';
import {ComboProductsRoutingModule} from './combo-products-routing.module';

@NgModule({
  imports: [
    ComboProductsRoutingModule,
  ]
})
export class ComboProductsModule {
}
